import { Tooltip } from 'antd';
import { cn } from '../../../utils/string/cn.utils';
import { useTranslation } from 'react-i18next';

const CardItem = ({
  icon,
  title,
  content,
  quantity = 1,
  classNames = {
    root: '',
    icon: '',
    iconContainer: '',
    title: '',
    content: '',
    contentContainer: '',
  },
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'flex items-start self-stretch lg:gap-[0px] gap-[16px]',
        classNames?.root
      )}
      {...props}
    >
      <div
        className={cn(
          'flex lg:p-[8px] items-center gap-[10px] self-stretch overflow-hidden',
          classNames?.iconContainer
        )}
      >
        <img
          src={icon}
          alt=""
          className={cn(
            'w-[88px] h-[88px] rounded-[8px] object-cover  border-[1px] border-[#E3E5E8] bg-fills-white aspect-square',
            classNames?.icon
          )}
        />
      </div>
      <div
        className={cn(
          'flex lg:p-[8px] items-start self-stretch gap-[8px] grow',
          classNames?.contentContainer
        )}
      >
        <div className="flex flex-col justify-center items-start gap-[6px] grow">
          <Tooltip
            title={<span style={{ maxWidth: '200px' }}>{title}</span>}
            getPopupContainer={() => document.body}
            destroyOnHidden
            placement="top"
          >
            <div
              className={cn(
                'line-clamp-1 self-stretch text-black-high',
                classNames?.title,
                'text-title-small'
              )}
            >
              {t(title)}
            </div>
          </Tooltip>
          <div
            className={cn(
              'flex items-start content-start self-stretch flex-wrap gap-[4px]',
              classNames?.content
            )}
          >
            {content}
          </div>
        </div>
        {quantity ? (
          <div className="flex items-center self-stretch p-[8px] gap-[10px]">
            <div className="text-body-medium text-black-medium emphasized line-clamp-1">
              x{quantity}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default CardItem;
